import type { VehicleImage } from '@core/Entities/Vehicle/VehicleImage.entity';

import type { ImageObj } from '../Entities/SharedEntities.types';
import { getAbsoluteMediaUrl } from './GetAbsoluteMediaUrl';

export const mapMediaImages = (images: ImageObj[]): VehicleImage[] =>
  images.map(({ url }) => ({
    url: getAbsoluteMediaUrl(url),
    isRelative: false,
  }));
